import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

interface FloatCardProps {
  children: ReactNode;
  /** Stagger index so a grid of cards floats out of phase. */
  index?: number;
  className?: string;
}

// A5 "Card_falls" from animation.md — a slow hovering/settling float with a
// gentle rotate, giving static tiles a bit of life. Stagger by index across a
// grid. Kept very subtle (investor-grade) and reduced-motion aware.
export function FloatCard({ children, index = 0, className = '' }: FloatCardProps) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      animate={{ y: [0, -8, 0], rotate: [0, index % 2 === 0 ? 0.6 : -0.6, 0] }}
      transition={{ duration: 7 + (index % 3), repeat: Infinity, ease: 'easeInOut', delay: index * 0.4 }}
    >
      {children}
    </motion.div>
  );
}
